import { serviceLogger } from '../Logger';
import { PointsInfoBannerService } from './PointsInfoBannerService';
import { PointsInfoBannerClient } from './PointsInfoBannerClient';
import HtmlCache from '../HtmlCache';
import { eventQBus as defaultEventQBus } from '@otto-ec/global-resources/event-q-bus';

const log = serviceLogger.scope('points-info-banner-app');

const debugEventBus = {
	on: (topicName: string) => {
		log.warn(`Registering on topic ${topicName} via debug eventBus.`);
	}
};

const eventQBus = defaultEventQBus ?? debugEventBus as never;

const pointsInfoBannerService = new PointsInfoBannerService(eventQBus,
	new PointsInfoBannerClient(), new HtmlCache());

pointsInfoBannerService.registerEventListeners().then(() => log.info('Registered event listener for points info banner'));
